export default __webpack_public_path__ + "static/media/news-19.13852c4b.jpg";